// Product ids
// "product" and "ticket" can (mostly, I guess) be used interchangeably.
export enum Product {
  singleZoneAAdultOmbud = 40,
  singleZoneAAdultTapAndGo = 2440,
  singleZoneAAdultOnboard = 5101,
  // Arbitrary - doesn't exist in the master data API
  singleZoneAYouthTapAndGo = 99999,
}
